import { Container, Row, Col, Button } from 'react-bootstrap';
import './contact.css';
import { useContactStore } from '../../../../store/useContactStore';
import { useEffect, useState } from 'react';
import Loader from '../../../Loader';


function ContactBanner() {
    const { banner, getBanner } = useContactStore()
    const [loading, setLoading] = useState(false)

    const fetchBannerData = async () => {
        setLoading(true)
        await getBanner()
        setLoading(false)
    }

    useEffect(() => {
        if (!banner) {
            fetchBannerData()
        }
    }, [banner, getBanner])
    return (
        <div>
            <Loader loading={loading}>
                <div className="contact-banner-section" style={{
                    "--contact-bg": banner?.image ? `url(${banner.image})` : ""
                }}>
                    <div className="contact-banner-overlay" />
                    <Container className="theme-container">
                        <Row className="align-items-center">
                             <Col md={8} lg={6}>
                                <div className='contact-banner-content'>
                                    <p className="section-subtitle mb-xl-2 mb-1">{banner?.subTitle}</p>
                                    <h2 className="section-sub-title mb-xl-3 mb-2">
                                        {banner?.title}
                                    </h2>
                                    <p className="contact-banner-description fontsize-20">
                                        {banner?.description}
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Loader>
        </div>
    )
}

export default ContactBanner
